<template>
    <div>
        <el-input-number
            @change="handleChange"
            :step="0.5"  
            :placeholder="placeholder"
            :disabled="disabled"
            style="width: 50%;" 
            v-model="time" 
        >
        </el-input-number>
        <el-select v-model="unit" slot="append" placeholder="请选择" :disabled="disabled"  @change="handleChange">
            <el-option label="天" value="D"></el-option>
            <el-option label="小时" value="H"></el-option>
            <el-option label="分钟" value="M"></el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    name: "Duration",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "请输入审批时限",
        },
        value: {
            type: Object,
        },
    },
    data() {
        return {
            time: undefined,
            unit: 'D'
        }
    },
    watch: {
        value: {
            handler: function(v) {
                const { time, unit } = v || {};
                if(time || unit) {
                    this.time = time
                    this.unit = unit
                } else {
                    this.time = undefined
                    this.unit = 'D'
                }
            },
            immediate: true
        }
    },
    methods: {
        async handleChange() {
            const [ time, unit ] = [this.time, this.unit];
            this.$emit("input", { time , unit });
        },
    },
  };
</script>